import { HTTPStatusCode } from "@libs/api/types";
import {
  AddDocumentParamsType,
  ListDocumentsFilterType,
  PresignedUrlForUploadParamsType,
} from "@/domain/uploadedDocuments";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const UploadedDocumentsApi = {
  generatePresignedUrlForUpload: async (
    params: PresignedUrlForUploadParamsType,
  ) => {
    const res =
      await tsRestClient().uploadedDocuments.generatePresignedUrlForUpload({
        body: params,
      });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to generate presigned URL for upload",
      shouldThrowError: true,
    });
  },

  addDocument: async (params: AddDocumentParamsType) => {
    const res = await tsRestClient().uploadedDocuments.addDocument({
      body: params,
    });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to add document",
      shouldThrowError: true,
    });
  },

  listDocuments: async (filters: ListDocumentsFilterType) => {
    const res = await tsRestClient().uploadedDocuments.listDocuments({
      query: filters,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to list documents",
      shouldThrowError: true,
    });
  },

  getDocument: async (documentId: string) => {
    const res = await tsRestClient().uploadedDocuments.getDocument({
      params: { id: documentId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to get document",
      shouldThrowError: true,
    });
  },

  deleteDocument: async (documentId: string) => {
    const res = await tsRestClient().uploadedDocuments.deleteDocument({
      params: { id: documentId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return;
    }

    logger.error({
      error: res.body,
      message: "Failed to delete document",
      shouldThrowError: true,
    });
  },

  listDocumentCategories: async () => {
    const res = await tsRestClient().uploadedDocuments.listDocumentCategories();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to list document categories",
      shouldThrowError: true,
    });
  },

  listDocumentRequirements: async () => {
    const res =
      await tsRestClient().uploadedDocuments.listDocumentRequirements();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to list document requirements",
      shouldThrowError: true,
    });
  },
};
